var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","wrap":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"title primary--text mb-5"},[_vm._v(_vm._s(_vm.message))]),_c('div',[_c('v-btn',{attrs:{"color":"primary background--text"},on:{"click":function($event){return _vm.onFirstWatch()}}},[_vm._v(_vm._s(_vm.$t("vod.btn.watch.now")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }